import React from 'react';


class History extends React.Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        return (
            <>
                <div className="flex flex-col container bg-gray-100">                
                    <h1>History</h1>
                </div>
            </>
        )
    }
}

export default History;